import { SvgIcon, SvgIconProps } from '@mui/material';

const WarningOutlined = ({ fill, fillOpacity, sx, ...props }: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      data-testid="WarningOutlinedIcon"
      sx={{
        fill: fill,
        fillOpacity: fillOpacity ?? 1,
        ...sx
      }}
    >
      <path d="M12 16.5011C12.5526 16.5011 13.0005 16.9487 13.0005 17.5009C13.0005 18.0531 12.5526 18.5007 12 18.5007C11.4476 18.5004 10.9994 18.0529 10.9994 17.5009C10.9994 16.9489 11.4476 16.5013 12 16.5011Z" />
      <path d="M12 10.0024C12.5526 10.0024 13.0005 10.45 13.0005 11.0022V14.5015C13.0005 15.0536 12.5526 15.5013 12 15.5013C11.4476 15.501 10.9994 15.0535 10.9994 14.5015V11.0022C10.9994 10.4501 11.4476 10.0026 12 10.0024Z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.1948 2.39833C11.5946 1.86724 12.4051 1.86721 12.8051 2.39833L12.8843 2.5194L22.8716 20.4993C23.2455 21.1729 22.7582 22 21.9872 22H2.01267C1.24189 21.9997 0.754548 21.1727 1.12837 20.4993L11.1157 2.5194L11.1948 2.39833ZM3.69335 20.0004H20.3066L12 5.04821L3.69335 20.0004Z"
      />
    </SvgIcon>
  );
};

export default WarningOutlined;
